import React, { useState } from "react";
import {
  useStripe,
  useElements,
  PaymentElement,
} from "@stripe/react-stripe-js";
import { environment } from "../../environments/environments";
import Swal from "sweetalert2";
const CheckoutForm = ({ clientSecret, user }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [isProcessing, setIsProcessing] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setIsProcessing(true);
    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: window.location.href,
        payment_method_data: {
          billing_details: {
            name: user?.name || "User",
            email: user?.email || "",
          },
        },
      },
    });

    if (error) {
      //   alert(`Payment failed: ${error.message}`);
      Swal.fire({
        icon: "error",
        title: "Payment Failed",
        text: error.message,
      });
    } else {
      //   alert("Payment successful!");
      //   window.location.href = "/gender";
      Swal.fire({
        icon: "success",
        title: "Payment Successful",
        text: "Your payment was completed successfully!",
        confirmButtonText: "Continue",
      }).then(() => {
        window.location.href = "/gender";
      });
    }
    setIsProcessing(false);
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      <button
        type="submit"
        disabled={isProcessing || !stripe}
        style={{
          marginTop: 20,
          backgroundColor: environment?.Coral_Red,
          width: "100%",
        }}
      >
        {isProcessing ? "Processing..." : "Pay Now"}
      </button>
    </form>
  );
};

export default CheckoutForm;
